export const ESTIMATE_BANNER_COPY = {
  title: 'Kick the tires',
  description: (
    <>
      Get instant, estimated <strong>Commercial Auto Liability</strong> pricing with your DOT number.
    </>
  ),
  buttonLabel: 'Get free estimates',
  buttonLabelMobile: 'Get estimates',
}
